"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.TableDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var icon_1 = require("./icon");
var table_cell_1 = require("./table-cell");
var drag_handle_1 = require("./drag-handle");
var table_cell_title_1 = require("./table-cell-title");
var chevron_up_icon_1 = require("../icons/chevron-up.icon");
var chevron_down_icon_1 = require("../icons/chevron-down.icon");
exports.TableDefaultProps = {
  rows: [],
  data: {},
  variant: "form",
  isSortable: false,
  onRowsChange: function (rows) {}
};
var DEFAULT_COLUMN_SPEC = {
  title: '',
  align: "center",
  iconSize: 20,
  pad: "all",
  justify: "flex-start",
  render: function (_a) {
    var value = _a.value,
      spec = _a.spec;
    return react_1.default.createElement(table_cell_1.TableCell, {
      spec: spec
    }, value);
  }
};
// -------- Styles -------->
var WIDTH = function (props) {
  return props._width && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n"], ["\n  width: ", ";\n"])), props._width);
};
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    ", ";\n    flex-direction: column;\n    border: 1px solid ", ";\n    border-collapse: collapse;\n\n    ", "\n  "], ["\n    width: 100%;\n    box-sizing: border-box;\n    display: flex;\n    ", ";\n    flex-direction: column;\n    border: 1px solid ", ";\n    border-collapse: collapse;\n\n    ", "\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('line-semi-subtle'), function (props) {
    return props.variant === "list" && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border: none;\n    "], ["\n      border: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  "], ["\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var TableHeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: none;\n    font-weight: 400;\n    font-size: ", ";\n    text-transform: uppercase;\n    border-bottom: 1px solid ", ";\n    background-color: ", ";\n    \n    /* ", " */\n  "], ["\n    display: none;\n    font-weight: 400;\n    font-size: ", ";\n    text-transform: uppercase;\n    border-bottom: 1px solid ", ";\n    background-color: ", ";\n    \n    /* ", " */\n  "])), theme_1.theme.FONT_SIZE(13), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.COLOR('app-chrome'), function (props) {
    return props.variant === 'list' && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      background: none;\n    "], ["\n      background: none;\n    "])));
  }),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    display: flex;\n  "], ["\n    display: flex;\n  "])))
});
var TableHeadRowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n  "], ["\n    display: flex;\n    width: 100%;\n  "])))
});
var TableBodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var TableHeadCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    padding: 0;\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n\n    padding: ", " ", ";\n    ", "\n\n    ", "\n\n\n  "], ["\n    padding: 0;\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n\n    padding: ", " ", ";\n    ", "\n\n    ", "\n\n\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3), function (props) {
    return props._justify && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      justify-content: ", ";\n    "], ["\n      justify-content: ", ";\n    "])), props._justify);
  }, function (props) {
    return props.isSortable && (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      cursor: pointer;\n      &:hover {\n        * {\n          color: ", ";\n        }\n      }\n    "], ["\n      cursor: pointer;\n      &:hover {\n        * {\n          color: ", ";\n        }\n      }\n    "])), theme_1.theme.COLOR('primary'));
  }),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), WIDTH)
});
var TableBodyHeadCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    padding: 0;\n  "], ["\n    padding: 0;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), WIDTH)
});
var TableCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    padding: 0;\n    font-size: 14px;\n\n  "], ["\n    padding: 0;\n    font-size: 14px;\n\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    text-overflow: ellipsis;\n    position: relative;\n    ", ";\n\n    ", ";\n\n    ", ";\n  "], ["\n    text-overflow: ellipsis;\n    position: relative;\n    ", ";\n\n    ", ";\n\n    ", ";\n  "])), WIDTH, function (props) {
    return (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      align-self: ", ";\n      justify-content: ", ";\n    "], ["\n      align-self: ", ";\n      justify-content: ", ";\n    "])), props._align, props._justify);
  }, function (props) {
    return props._whiteSpace && (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n      white-space: ", ";\n    "], ["\n      white-space: ", ";\n    "])), props.__whiteSpace);
  })
});
var TableRowStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n    position: relative;\n\n    &:first-child {\n      border-top: none;\n      background-image: none;\n    }\n\n    ", "\n\n    ", "\n    \n  "], ["\n    display: flex;\n    flex-direction: column;\n    border-top: 1px solid ", ";\n    position: relative;\n\n    &:first-child {\n      border-top: none;\n      background-image: none;\n    }\n\n    ", "\n\n    ", "\n    \n  "])), theme_1.theme.COLOR('line-subtle'), function (props) {
    return props.isDragging && (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      border: 1px solid ", ";\n      box-shadow: 0px 2px 2px -2px rgba(0,0,0,0.4);\n      background-image: none;\n\n      &:first-child {\n        border: 1px solid ", ";\n      }\n    "], ["\n      border: 1px solid ", ";\n      box-shadow: 0px 2px 2px -2px rgba(0,0,0,0.4);\n      background-image: none;\n\n      &:first-child {\n        border: 1px solid ", ";\n      }\n    "])), theme_1.theme.COLOR('line-semi-subtle'), theme_1.theme.COLOR('line-semi-subtle'));
  }, function (props) {
    return props.variant === "list" && (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      /* border-top: none;\n      /* ", "; */\n    "], ["\n      /* border-top: none;\n      /* ", "; */\n    "])), theme_1.theme.DOT_BG('h', 'line-semi-subtle', 2, 4));
  }),
  tablet: (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n    /* ", "; */\n    /* border-top: none; */\n    background-color: #FFF;\n    align-items: center;\n    flex-direction: row;\n    position: static;\n    ", "\n  "], ["\n    /* ", "; */\n    /* border-top: none; */\n    background-color: #FFF;\n    align-items: center;\n    flex-direction: row;\n    position: static;\n    ", "\n  "])), theme_1.theme.DOT_BG('h', 'line-semi-subtle', 2, 4), function (props) {
    return props.isDragging && (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      background-image: none;\n      border-top: 1px solid ", ";\n    "], ["\n      background-image: none;\n      border-top: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-semi-subtle'));
  })
});
var TableCellTitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DragHandleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    border-right: none;\n    transform: translateY(-50%);\n  "], ["\n    position: absolute;\n    right: 0px;\n    top: 50%;\n    border-right: none;\n    transform: translateY(-50%);\n  "])))
});
var TableHeaderCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    padding: 0;\n    background: ", ";\n    box-shadow: 0 1px 3px -2px rgba(0,0,0,0.5);\n    background-position: bottom left;\n    width: 100%;\n    position: relative;\n    z-index: 1;\n\n    ", "\n  "], ["\n    padding: 0;\n    background: ", ";\n    box-shadow: 0 1px 3px -2px rgba(0,0,0,0.5);\n    background-position: bottom left;\n    width: 100%;\n    position: relative;\n    z-index: 1;\n\n    ", "\n  "])), theme_1.theme.COLOR('table-header'), function (props) {
    return props.variant === "list" && (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      background: none;\n      box-shadow: none;\n      border-bottom: 1px solid ", ";\n    "], ["\n      background: none;\n      box-shadow: none;\n      border-bottom: 1px solid ", ";\n    "])), theme_1.theme.COLOR('line-semi-subtle'));
  })
});
var TableFooterCellStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    width: 100%;\n    padding: 0;\n    background: #FFF;\n    border-top: 2px dotted ", ";\n\n    ", "\n\n    ", "\n\n  "], ["\n    width: 100%;\n    padding: 0;\n    background: #FFF;\n    border-top: 2px dotted ", ";\n\n    ", "\n\n    ", "\n\n  "])), theme_1.theme.COLOR('line-semi-subtle'), function (props) {
    return props.count === 0 && (0, styled_components_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      border-top: none;\n    "], ["\n      border-top: none;\n    "])));
  }, function (props) {
    return props.variant === "list" && (0, styled_components_1.css)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      background: none;\n    "], ["\n      background: none;\n    "])));
  })
});
var SortIconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    margin-left: ", ";\n  "], ["\n    margin-left: ", ";\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SortIcon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), SortIconStyles),
  Table: styled_components_1.default.table(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  TableHeaderCell: styled_components_1.default.td(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), TableHeaderCellStyles),
  TableFooterCell: styled_components_1.default.td(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), TableFooterCellStyles),
  TableCellTitle: (0, styled_components_1.default)(table_cell_title_1.TableCellTitle)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), TableCellTitleStyles),
  TableHead: styled_components_1.default.thead(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), TableHeadStyles),
  TableHeadRow: styled_components_1.default.tr(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), TableHeadRowStyles),
  TableHeadCell: styled_components_1.default.th(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), TableHeadCellStyles),
  TableBody: styled_components_1.default.tbody(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), TableBodyStyles),
  TableRow: styled_components_1.default.tr(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), TableRowStyles),
  TableBodyHeadCell: styled_components_1.default.th(templateObject_46 || (templateObject_46 = __makeTemplateObject(["", ""], ["", ""])), TableBodyHeadCellStyles),
  TableCell: styled_components_1.default.td(templateObject_47 || (templateObject_47 = __makeTemplateObject(["", ""], ["", ""])), TableCellStyles),
  DragHandle: (0, styled_components_1.default)(drag_handle_1.DragHandle)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["", ""], ["", ""])), DragHandleStyles)
};
var Table = function (props) {
  var className = props.className,
    data = props.data,
    columns = props.columns,
    isSortable = props.isSortable,
    header = props.header,
    footer = props.footer,
    rows = props.rows,
    onRowsChange = props.onRowsChange,
    variant = props.variant;
  var cellsWithoutWidth = (0, lodash_1.filter)(columns, function (cell) {
    return cell.width === undefined;
  });
  var autoWidth = cellsWithoutWidth.length == (0, lodash_1.values)(columns).length ? "".concat(1 / cellsWithoutWidth.length * 100, "%") : 'auto';
  var onDragEnd = function (result, responded) {
    var destination = result.destination,
      source = result.source,
      draggableId = result.draggableId;
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }
    var newRows = Array.from(rows);
    newRows.splice(source.index, 1);
    newRows.splice(destination.index, 0, draggableId);
    onRowsChange(newRows);
  };
  var onTableHeadCellClick = function (name) {
    return function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (props.onTableHeadCellClick) {
        props.onTableHeadCellClick(name);
      }
    };
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Table, {
    variant: variant,
    cellSpacing: 0
  }, react_1.default.createElement(My.TableHead, {
    variant: variant
  }, react_1.default.createElement(My.TableHeadRow, null, (0, lodash_1.map)(columns, function (spec, name) {
    return react_1.default.createElement(My.TableHeadCell, {
      isSortable: spec.isSortable,
      _justify: spec.justify,
      key: "head-".concat(name),
      _width: spec.width || autoWidth,
      onClick: spec.isSortable ? onTableHeadCellClick(name) : undefined
    }, react_1.default.createElement(My.TableCellTitle, {
      spec: spec
    }, spec.orderByDirection && react_1.default.createElement(My.SortIcon, {
      color: "text",
      size: 12
    }, spec.orderByDirection === "asc" ? react_1.default.createElement(chevron_up_icon_1.ChevronUp, null) : react_1.default.createElement(chevron_down_icon_1.ChevronDown, null))));
  }))), header && react_1.default.createElement(My.TableBody, null, react_1.default.createElement(My.TableRow, {
    key: "header",
    variant: variant
  }, react_1.default.createElement(My.TableHeaderCell, {
    variant: variant
  }, header))), isSortable && rows.length > 1 ? react_1.default.createElement(react_beautiful_dnd_1.DragDropContext, {
    onDragEnd: onDragEnd
  }, react_1.default.createElement(react_beautiful_dnd_1.Droppable, {
    droppableId: "rows"
  }, function (provided) {
    return react_1.default.createElement(My.TableBody, __assign({
      ref: provided.innerRef
    }, provided.droppableProps), rows.map(function (rowId, index) {
      var row = data[rowId];
      if (!row) {
        return null;
      }
      return react_1.default.createElement(react_beautiful_dnd_1.Draggable, {
        key: rowId,
        draggableId: rowId,
        index: index
      }, function (provided, snapshot) {
        return react_1.default.createElement(My.TableRow, __assign({
          isDragging: snapshot.isDragging
        }, provided.draggableProps, {
          ref: provided.innerRef,
          key: rowId
        }), row.cells.map(function (cell, index) {
          var isLast = index === row.cells.length - 1;
          var spec = __assign(__assign(__assign({}, DEFAULT_COLUMN_SPEC), columns[cell.name] || {}), {
            isLast: isLast
          });
          return react_1.default.createElement(My.TableCell, {
            key: "".concat(rowId, "-").concat(cell.name),
            spec: spec,
            _align: spec.align,
            _justify: spec.justify,
            _whiteSpace: spec.whiteSpace,
            _width: spec.width || autoWidth
          }, spec.render({
            value: cell.value,
            spec: spec
          }), isLast && react_1.default.createElement(My.DragHandle, __assign({
            isDragging: snapshot.isDragging
          }, provided.dragHandleProps)));
        }));
      });
    }), provided.placeholder);
  })) : react_1.default.createElement(My.TableBody, null, rows.map(function (rowId, index) {
    var row = data[rowId];
    if (!row) {
      return null;
    }
    return react_1.default.createElement(My.TableRow, {
      variant: variant,
      key: rowId
    }, row.cells.map(function (cell, index) {
      var isLast = index === row.cells.length - 1;
      var spec = __assign(__assign(__assign({}, DEFAULT_COLUMN_SPEC), columns[cell.name] || {}), {
        isLast: isLast
      });
      return react_1.default.createElement(My.TableCell, {
        key: "".concat(rowId, "-").concat(cell.name),
        spec: spec,
        _align: spec.align,
        _justify: spec.justify,
        _whiteSpace: spec.whiteSpace,
        _width: spec.width || autoWidth
      }, spec.render({
        value: cell.value,
        spec: spec
      }));
    }));
  })), footer && react_1.default.createElement(My.TableBody, null, react_1.default.createElement(My.TableRow, {
    key: "footer"
  }, react_1.default.createElement(My.TableFooterCell, {
    variant: variant,
    count: rows.length
  }, footer)))));
};
exports.Table = Table;
exports.Table.defaultProps = exports.TableDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48;